module.exports = __webpack_public_path__ + "static/img/ace.badcf1d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ace.svg
// module id = ivSs
// module chunks = 1